// extracted by mini-css-extract-plugin
export default {"Btn":"Button_Btn__TWTPA"};